module.exports = __webpack_public_path__ + "img/default-pdf.5f4ee761.jpeg";